/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsImageOverlayBlocks = {
    init: function ($section) {
      this.$section = $section
      this.$sliderEl = $section.find('.slider-wrapper');
      this.$slides =  this.$sliderEl.find('[data-index]')

      this.$slider = this.$sliderEl.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        watchCSS: true,
        cellAlign:'left'
      });

      $(document).on('Resize:Custom', this.adjustPeak.bind(this));
      this.adjustPeak()
    },
    adjustPeak: function () {
      this.$slides.each((index,slide)=>{
        $(slide)[0].style.removeProperty('width')
      })
      if(!isScreenSizeLarge()){
        let width = this.$slides.eq(0).width()
        this.$slides.css('width', width - width / 16 + 'px')
      }
      this.$slider.flickity('resize')
    },
    blockSelect: function ($section, blockId) {
      const $slider = $section.find('.slider-wrapper');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $slider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;